var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26413 6.26413C6.61631 5.91196 7.1873 5.91196 7.53948 6.26413L12 10.7247L16.4605 6.26413C16.8127 5.91196 17.3837 5.91196 17.7359 6.26413C18.088 6.61631 18.088 7.1873 17.7359 7.53948L13.2753 12L17.7359 16.4605C18.088 16.8127 18.088 17.3837 17.7359 17.7359C17.3837 18.088 16.8127 18.088 16.4605 17.7359L12 13.2753L7.53948 17.7359C7.1873 18.088 6.61631 18.088 6.26413 17.7359C5.91196 17.3837 5.91196 16.8127 6.26413 16.4605L10.7247 12L6.26413 7.53948C5.91196 7.1873 5.91196 6.61631 6.26413 6.26413Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.80fd45f12f289c4d175e4ce4ea344ac7.svg";
export { ForwardRef as ReactComponent };